// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3dHo9","rightAdornment":"Header_rightAdornment__2TREC"};